<template>
  <div class="finish-page-template">
    <OnBoardingActivity
      v-if="onboardOutro"
      class="onboard-activity"
      @load="loading"
      @loaded="loaded"
      :aid="onboardOutro"
    />
    <div style="justify-content: center;" class="input-wrapper">
      <h3>Thank you</h3>
    </div>
    <div class="input-wrapper">
      <Button long @click="finish" style="margin-top: 10px;" size="large" type="primary">Finish</Button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OnBoardingActivity from "@/components/OnBoardingActivity";
import _ from "lodash"
import VueCookie from "vue-cookie";
import Cons from "@/constants.json";

export default {
  name: "FinishPage",
  data() {
    return {
      isLoading: false
    };
  },
  components: {
    OnBoardingActivity
  },
  computed: {
    ...mapGetters("user", ["userInfo", "brandInfo"]),
    onboardOutro() {
      if (_.get(this.brandInfo, "resource_id.onboarding_outro"))
        return _.get(this.brandInfo, "resource_id.onboarding_outro");
      else if (_.get(this.brandInfo, "network_resource.onboarding_outro"))
        return _.get(this.brandInfo, "network_resource.onboarding_outro");
      else return _.get(this.brandInfo, "global_resource.onboarding_outro");
    },
    // onboardOutro() {
    //   if (this.brandInfo.resource_id)
    //     return this.brandInfo.global_resource.onboarding_outro || null;
    //   return null;
    //   // return "89AD21EC-759B-3C73-573C-20E14CA5B381"
    // }
  },
  methods: {
    loaded() {
      this.isLoading = false;
      this.$emit("onLoaded");
    },
    loading() {
      this.isLoading = true;
      this.$emit("onLoading");
    },
    async finish() {
      //delete prescription
      VueCookie.delete("PRESCRIPTION_CODE");
      VueCookie.delete("PRESCRIPTION_MOBILE");

      //fetch /me for ios app caching
      this.$store.dispatch("user/getUser")

      //fetch selected user story for ios app caching
      await this.$store.dispatch("library/getUserStories", Cons[0].BRAND_ID)

      this.goToPath(`/${this.$route.params.brandSlug}/home`);
    },
    goToPath(path) {
      this.$emit("goToPath", path);
    }
  }
};
</script>

<style lang="scss" scoped>
.onboard-consent-page-template {
  height: 100%;
}
.onboard-activity {
  max-height: 75vh;
  overflow-y: auto;
}
</style>